import React from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { theme } from '../theme';
import { DEFAULT_MAINTENANCE_MESSAGE, formatEta, } from './maintenanceState';
/** Full-screen maintenance view (native). Display only. */
export function MaintenanceScreenView({ info, now, }) {
    const eta = formatEta(info.until, now);
    return (<View style={styles.screen} testID="maintenance-screen" accessibilityRole="alert">
      <Text style={styles.title}>We'll be right back</Text>
      <Text style={styles.message}>
        {info.message || DEFAULT_MAINTENANCE_MESSAGE}
      </Text>
      {eta && <Text style={styles.eta}>{eta}</Text>}
      <View style={styles.status}>
        <ActivityIndicator color={theme.colors.primary}/>
        <Text style={styles.statusText}>Checking again automatically…</Text>
      </View>
    </View>);
}
/** Top banner (web and admin): the site keeps working for reading; saving waits. */
export function MaintenanceBannerView({ info, now, }) {
    const eta = formatEta(info.until, now);
    return (<View style={styles.banner} testID="maintenance-banner" accessibilityRole="alert">
      <Text style={styles.bannerText}>
        {`Maintenance in progress: ${info.message || DEFAULT_MAINTENANCE_MESSAGE} You can browse, but changes can't be saved right now.${eta ? ` ${eta}.` : ''}`}
      </Text>
    </View>);
}
const styles = StyleSheet.create({
    screen: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.colors.background,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
        zIndex: 1000,
    },
    title: {
        fontSize: 24,
        fontWeight: '700',
        color: theme.colors.onBackground,
        marginBottom: 12,
        textAlign: 'center',
    },
    message: {
        fontSize: 16,
        color: theme.colors.onBackground,
        textAlign: 'center',
        lineHeight: 22,
    },
    eta: {
        marginTop: 12,
        fontSize: 15,
        fontWeight: '600',
        color: theme.colors.primary,
    },
    status: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 28,
        gap: 8,
    },
    statusText: { fontSize: 13, color: theme.colors.onSurfaceVariant },
    banner: {
        backgroundColor: '#FEF3C7',
        paddingVertical: 8,
        paddingHorizontal: 16,
    },
    bannerText: { color: '#78350F', fontSize: 14, textAlign: 'center' },
});
